// Shared text-case helpers used by Sales Form (customer name, accessory items)
// and any display surface that needs a consistent presentation. Keep this file
// pure utility — no React imports.

const TITLE_KEEP_AS_IS = new Set(["of", "the", "and"]);

/**
 * Title-Case a free-form name. Collapses runs of whitespace, trims edges,
 * and ensures the first letter of every word is capitalised regardless of
 * the original casing.
 *
 * Examples:
 *   "deepak patnaik"   → "Deepak Patnaik"
 *   "DEEPAK PATNAIK"   → "Deepak Patnaik"
 *   "  r k  nayak "    → "R K Nayak"
 *   "seat   cover"     → "Seat Cover"
 */
export function toTitleCase(input) {
  if (input == null) return "";
  const str = String(input).replace(/\s+/g, " ").trim();
  if (!str) return "";
  return str
    .split(" ")
    .map((word, i) => {
      if (!word) return word;
      // Preserve single-letter initials in upper-case (e.g. "R", "K").
      if (word.length === 1) return word.toUpperCase();
      const lower = word.toLowerCase();
      if (i > 0 && TITLE_KEEP_AS_IS.has(lower)) return lower;
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join(" ");
}
